// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/sandbox/v2/service.proto (package chalk.sandbox.v2, syntax proto3)
/* eslint-disable */

import { SandboxService } from "./service_pb";

/**
 * @generated from rpc chalk.sandbox.v2.SandboxService.CreateSandbox
 */
export const createSandbox = SandboxService.method.createSandbox;

/**
 * @generated from rpc chalk.sandbox.v2.SandboxService.GetSandbox
 */
export const getSandbox = SandboxService.method.getSandbox;

/**
 * @generated from rpc chalk.sandbox.v2.SandboxService.ListSandboxes
 */
export const listSandboxes = SandboxService.method.listSandboxes;

/**
 * @generated from rpc chalk.sandbox.v2.SandboxService.SuspendSandbox
 */
export const suspendSandbox = SandboxService.method.suspendSandbox;

/**
 * @generated from rpc chalk.sandbox.v2.SandboxService.ResumeSandbox
 */
export const resumeSandbox = SandboxService.method.resumeSandbox;

/**
 * @generated from rpc chalk.sandbox.v2.SandboxService.TerminateSandbox
 */
export const terminateSandbox = SandboxService.method.terminateSandbox;
